import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../context/AuthContext';
import DataTable from 'react-data-table-component';
import { FaUserFriends } from 'react-icons/fa';
import { MdDelete, MdEdit } from 'react-icons/md';
import styles from "./clientes.module.css";
import { IoCloseSharp } from "react-icons/io5";
import Swal from 'sweetalert2';
import { api } from '../../utils/services/api';
import { SERVICE } from '../../utils/constants/services';
import Select from 'react-select'
import { PDFDocument } from 'pdf-lib';

export default function ModalPDF(props) {
    const { show, setShow, pdfBase64 } = props;
    const [pdfUrl, setPdfUrl] = useState('');
    useEffect(() => {
        const loadPdf = async () => {
            const bytes = Uint8Array.from(atob(pdfBase64), c => c.charCodeAt(0));
            const blob = new Blob([bytes], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            setPdfUrl(url);
        };

        loadPdf();

        return () => {
            if (pdfUrl) URL.revokeObjectURL(pdfUrl);
        };
    }, [pdfBase64]);
    return (
        <>
            <div className={styles.bodyModal2} style={{ display: show ? "" : "none" }}>
                <div className={`${styles.containerFormMain} animate__animated animate__fadeInDown`} style={{ display: show ? "" : "none" }}>
                    <div className={styles.headerForm}>
                        <h5>Vizualizar Documento</h5>
                        <div className={styles.icon} onClick={() => setShow(false)}>
                            <IoCloseSharp />
                        </div>

                    </div>

                    <div className={styles.containerForm}>
                        {pdfUrl && (
                            <iframe
                                src={pdfUrl}
                                width="100%"
                                height="500px"
                                title="PDF Viewer"
                            />
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}